import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import queryString from "query-string";
import { getInput } from "actions/inputActions";

class Hydrate extends React.Component {
  componentDidMount() {
    const parameters = queryString.parse(this.props.location.search);
    const { recommendations_input_hash, eligibility_input_hash } = parameters;

    this.props.dispatch(
      getInput(recommendations_input_hash, eligibility_input_hash)
    );
  }

  render() {
    return null;
  }
}

export default withRouter(connect()(Hydrate));
